/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import UserProfile from 'containers/Users/SingleUser';

const AccountSettings = props => {
  return <UserProfile {...props} account />;
};

export default AccountSettings;
